export default {
    url: 'calculators/power-kits',
    include: ['us', 'jp', 'cn', 'ca', 'uk', 'au', 'de', 'fr', 'za', 'kr', 'eu'],
};
